import mixpanel from "mixpanel-browser";
import { createRoot } from "react-dom/client";
import TagManager from "react-gtm-module";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import "./index.css";

import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import { persistor, store } from "./Store/configureStore";
import { mixPanelKey } from "./variable";

const container = document.getElementById("app");
const root = createRoot(container);

if (import.meta.env.PROD) {
  const tagManagerArgs = {
    gtmId: "GTM-NNDHMGD",
  };
  TagManager.initialize(tagManagerArgs);
}

mixpanel.init(mixPanelKey, {
  property_blacklist: ["$current_url"],
});

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </ErrorBoundary>
);
